import React from 'react'
import { useInitialCofig } from '../hooks/initialConfig-hook';
import { Tabbar } from '../models/common/common';
import { fontSizeToViewport } from '../utils/function-utils';

//AVCDAAV.002  20/03/2025  Add code for Adding teb component

type Props = {
    setActiveIndex: React.Dispatch<React.SetStateAction<Tabbar>>;
    active: Tabbar;
    tabs: {key: Tabbar, name: string}[]
}

export const Tabs = (props: Props) => {
    const { initialConfig } = useInitialCofig();

    const handleClick = (name: Tabbar) => {
        props.setActiveIndex(name);
    }

    return (
        <div className='tab-container'>
            {props.tabs.map((data) => {
                return (
                    <div key={data.key} className='tab-item' onClick={() => handleClick(data.key)}
                        style={props.active === data.key ? 
                            {...initialConfig.styles.general_button_style_hover_active_style} : 
                            {...initialConfig.styles.general_button_style, backgroundColor: "white" }
                        }
                    >
                        {data.name}
                    </div>
                )
            })}
        </div>
    )
}

//C-AVCDAAV.002  20/03/2025  Add code for Adding teb component